import React from "react";
import { format } from "date-fns";

export const SimpleTableChart = ({ dataSet, def }) => {
	const borderClass = def.format.hideBorders
		? ""
		: `border border-${def.format.colours.grid || "white"}-200 p-2`;

	let topMargin = "";

	const rows = dataSet.data.map((e, rowIndex) => {
		const convert = (v, c) => {
			let ret = v;

			switch (c) {
				case "datetime":
					ret = format(new Date(parseInt(ret, 10)), "d MMM yyyy HH:mm");
					break;

				case "date":
					ret = format(new Date(parseInt(ret, 10)), "d MMM yyyy");
					break;

				default:
					ret = (ret || "").toString();
					break;
			}

			return ret;
		};

		const getValue = (value, cnv, def) => {
			let val = value;
			let prefix = def.valuePrefix || "";
			if (Array.isArray(val)) {
				return val.map((v, index) => {
					return (
						<>
							<span
								key={`${v.value}_${index}`}
								className={`${v.classes || ""}`}
								dangerouslySetInnerHTML={{
									__html:
										prefix + convert(v.value, cnv).replace(/\n/g, "<br/>"),
								}}
							></span>
							{index === val.length - 1 ? null : <br />}
						</>
					);
				});
			} else {
				return (
					<span
						dangerouslySetInnerHTML={{
							__html: prefix + convert(val, cnv).replace(/\n/g, "<br/>"),
						}}
					></span>
				);
			}
		};

		// process a header row
		if (e.type === "header") {
			const cs = `w-full mb-2 ${topMargin} ${e.classes || " text-lg"}`;
			topMargin = "mt-5";
			return (
				<div
					key={`row_${rowIndex}_header`}
					className={cs}
					dangerouslySetInnerHTML={{
						__html: e.label,
					}}
				></div>
			);
		}

		// this must be a data entry
		const cs = `mb-2 ${e.classes || "md:ml-2"}`;
		return (
			<div className={cs} key={`row_${rowIndex}_data`}>
				<span
					className={"pr-2 font-bold"}
					dangerouslySetInnerHTML={{
						__html: e.label + ":",
					}}
				></span>
				{getValue(e.value, e.cnv, e)}
			</div>
		);
	});

	if (!rows || !rows.length) {
		return (
			<div key="no-data" className="mt-4 text-center text-base">
				There is no information to display for this period
			</div>
		);
	}

	return (
		<div
			key="data-holder"
			className={`w-full text-sm ${borderClass} text-${def.format.colours.text}`}
		>
			{rows}
		</div>
	);
};
